import * as Backbone from 'backbone';
import * as _ from 'underscore';



import config from '../../common/config';

export var Model = Backbone.Model.extend({
    errors: [],
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
            Calculation: {}
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
    "sync": function (method, model, options) {
        if (method == 'read') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/-1';
        } else if (method == 'create') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/' + options.route + '/-1';
        } 
        return Backbone.sync(method, model, options);
    },
    initialize: function () {
        var that = this;
    },
    validateNoBackbone: function (attrs, app, callback) {
        this.errors = [];

        var self = this;

        var tmpModel = {};
        tmpModel.Method = 'GetEmailUsed';
        tmpModel.Value = attrs.Email;

        app.entities.collections.publicCustom.fetch ({
            silens : true,
            wait : true,
            tmpModel: tmpModel,
            success: function (mode, response) {
                callbackInternal(false);
            },
            error : function (mode, response) {
                callbackInternal(true);
            },
        });

        var callbackInternal = function (error) {

            //Fields required
            if (error) {
                self.errors.push({ name: 'register_inputEmail', message: resources.X200189 });
            }

            if (!attrs.Name) {
                self.errors.push({ name: 'register_inputName', message: resources.X200190 });
            }

            //if (!attrs.Contactperson_Name) {
            //    self.errors.push({ name: 'register_inputContactperson_Name', message: resources.X200190 });
            //}

            //if (!attrs.Contactperson_Email) {
            //    self.errors.push({ name: 'register_inputContactperson_Email', message: resources.X200190 });
            //}
            //else {
            //    var validate_Email = app.entities.collections.languageValidation_Collection.where({ Name: 'register_inputEmail' });
            //    if (validate_Email && validate_Email.length > 0) {
            //        var re = new RegExp(validate_Email[0].attributes.Value, 'g');
            //        if (attrs.Contactperson_Email.match(re) == null) {
            //            self.errors.push({ name: 'register_inputContactperson_Email', message: validate_Email[0].attributes.Error });
            //        }
            //    }
            //}

            if (!attrs.Contactperson_Phone) {
                self.errors.push({ name: 'register_inputContactperson_Phone', message: resources.X200190 });
            }

            if (!attrs.Address01) {
                self.errors.push({ name: 'register_inputAddress01', message: resources.X200190 });
            }

            //if (!attrs.WrongAddress) {
            //    self.errors.push({ name: 'register_inputAddress01', message: resources.X200191 });
            //}

            

            if (!attrs.Email) {
                self.errors.push({ name: 'register_inputEmail', message: resources.X200190 });
            }
            else {
                //^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$

                var validate_Email = app.entities.collections.languageValidation_Collection.where({ Name: 'register_inputEmail' });
                if (validate_Email && validate_Email.length > 0) {
                    var re = new RegExp(validate_Email[0].attributes.Value, 'g');
                    if (attrs.Email.match(re) == null) {
                        self.errors.push({ name: 'register_inputEmail', message: validate_Email[0].attributes.Error });
                    }
                }
            }

            if (!attrs.Password) {
                self.errors.push({ name: 'register_inputPassword', message: resources.X100324 });
            }
            //^(?=.*[a-z].*[a-z])(?=.*[A-Z].*[A-Z])(?=.*\d.*\d)(?=.*\W.*\W)[a-zA-Z0-9\S]{9,}$
            var validate_Password = app.entities.collections.languageValidation_Collection.where( {Name : 'register_inputPassword'});
            if (validate_Password && validate_Password.length > 0) {
                var re = new RegExp(validate_Password[0].attributes.Value, 'g');
                if(attrs.Password.match(re) == null) {
                    self.errors.push({ name: 'register_inputPassword', message: validate_Password[0].attributes.Error });
                }
            }
        
            if (!attrs.PasswordConfirm) {
                self.errors.push({ name: 'register_inputPasswordConfirm', message: resources.X100324 });
            }
            if (attrs.PasswordConfirm != attrs.Password) {
                self.errors.push({ name: 'register_inputPasswordConfirm', message: resources.X100597 });
            }

            
            if (self.errors.length > 0) {
                callback(false);
                //return true
            }
            else {
                callback(true);
                //return false;
            }
        }
        //return errors.length > 0 ? errors : false, 
    }
});

    